// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__2wx0p","subheader":"ReorderModal_subheader__7-Szg","listWrap":"ReorderModal_listWrap__1eWIn"};